import type { CoachingStatus } from '../../../modules/dashboard/composables/useCoachingInvitations'
import type { Member } from '../member/member'
import type { MemberOrUser } from '../member/member-or-user'


export interface Dialog {
  readonly id: string
  readonly phase: DialogPhase
  readonly coachee: MemberOrUser
  readonly coach: Member
  readonly createdAt: string
  readonly coachingStatus?: CoachingStatus
  readonly plannedAt?: string
  readonly coacheeDataReleasedAt?: string
  readonly coachDataReleasedAt?: string
  readonly conductedAt?: string
  readonly leadTimeStartsAt?: string
  readonly leadTimeOption?: DialogLeadTimeOption
}

export enum DialogLeadTimeOption {
  OneWeek = 'one_week',
  TwoWeeks = 'two_weeks',
  ThreeWeeks = 'three_weeks',
  Custom = 'custom',
}

export enum DialogPhase {
  Feedback = 'feedback',
  CoachPreparation = 'coach_preparation',
  Conversation = 'conversation',
  Conducted = 'conducted',
}
